exports = module.exports = require("../../../build/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ui-icon-label{display:-webkit-box;display:-webkit-flex;display:flex;-webkit-box-align:center;-webkit-align-items:center;align-items:center;-webkit-box-pack:center;-webkit-justify-content:center;justify-content:center;padding:0 7px 0 3px;height:20px;color:#737373;font-size:12px;background-color:#f7f7f7;border-radius:10px}.ui-icon-label__pic{width:14px;height:14px;margin-right:3px;border:none;border-radius:50%;overflow:hidden}.ui-icon-label__text{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!../src/ui/label/icon-label.vue
// module id = 566
// module chunks = 0 1 2 3